import Table from './TableStore';
import TableColumn from './TableColumn';

Table.Column = TableColumn;

export default Table;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/table/index.js
// module id = 448
// module chunks = 0